<div class="main-container">
    <div class="mdl-container">
        <div class="d-grid mdl-header">
            <div class="center-svg"><img src="assets/svg/segment-icon-org.svg" alt=""></div>
            <div><h4 class="text-semibold">{{data.mode === 'edit' ? "Modificar informaci&oacute;n segmento" : "Nuevo segmento"}}</h4><h6 class="color-gray" style="font-weight: 400;">{{data.mode === 'edit' ? "Completa los datos que necesitas modificar del segmento" : "Agrega los detalles para registrar un nuevo segmento para las campañas."}}</h6></div>
            <div><h3 class="color-gray text-semibold"><div class="center-svg"><img (click)="closeMdl();" class="close-button" src="assets/svg/close-icon.svg" alt=""></div></h3></div>
        </div>
        <div class="mdl-body">
            <div class="d-grid prospect-form">
                <div class="mt-5">
                    <label class="login-label" for="nombre">
                        <span class="required-asterisk" *ngIf="!request.nombre_segmento || request.nombre_segmento.trim()===''">*</span>
                        Nombre del segmento:
                    </label>
                    <input 
                    class="crm-input" 
                    type="text" 
                    name="name" 
                    id="name" 
                    [(ngModel)]="request.nombre_segmento"
                    required
                    #nameCtl="ngModel">
                    <div class="error-message" *ngIf="nameCtl.invalid && (nameCtl.dirty || nameCtl.touched)">
                        <small *ngIf="nameCtl.errors?.['required']">El nombre del segmento es obligatorio.</small>
                    </div>
                </div>
                <div class="mt-5">
                <label class="login-label" for="">
                    <p class="color-org d-inline">*</p> Ejecutivo asignado:
                </label>

                <select class="crm-input" [(ngModel)]="request.ejecutivo_id">
                <option value="">Selecciona ejecutivo</option>
                @for (ejecutivo of ejecutivos; track ejecutivo) {
                    <option [value]="ejecutivo.usuario_id">
                    {{ ejecutivo.nombre }} {{ ejecutivo.apellido }}
                    </option>
                }
                </select>

                @if (ejecutivos.length === 0) {
                <small class="color-gray">No hay ejecutivos disponibles.</small>
                }

                </div>
            </div>

            <div class="mt-5">
                <label class="login-label" for=""><p class="color-org d-inline">*</p> Tipo de modulo:</label>
            </div>

            <div class="d-flex flex-row gap-20 mt-3">
                <div>
                    <label class="radio-label"><input type="radio" value="PRO" name="tipo-entidad" required checked [(ngModel)]="request.tipo_entidad" (change)="onTipoEntidadChange()"/>Prospectos</label>
                </div>

                <div>
                    <label class="radio-label"><input type="radio" value="CNT" name="tipo-entidad" required [(ngModel)]="request.tipo_entidad" (change)="onTipoEntidadChange()"/>Contactos</label>
                </div>

                <div>
                    <label class="radio-label"><input type="radio" value="ACC" name="tipo-entidad" required [(ngModel)]="request.tipo_entidad" (change)="onTipoEntidadChange()"/>Cuentas</label>
                </div>
            </div>

            <div class="mt-5">
                <label class="login-label" for=""><p class="color-org d-inline">*</p> Tipo de selección de segmento:</label>
            </div>

            <div class="d-flex flex-row gap-20 mt-3">
                <div>
                    <label class="radio-label"><input type="radio" value="manual" name="tipo-seleccion"required checked [(ngModel)]="tipoSeleccion"/>Selección manual</label>
                </div>

                <div>
                    <label class="radio-label"><input type="radio" value="masiva" name="tipo-seleccion" required [(ngModel)]="tipoSeleccion"/>Selección masiva</label>
                </div>
            </div>

            @if(tipoSeleccion === 'manual'){
            <div class="prospect-form mt-5">
                <div>
                    <label class="login-label" for=""><p class="color-org d-inline">*</p> Selección manual:</label>
                    <ng-select 
                        class="crm-input"
                        [items]="getEntitiesByType()" 
                        [bindLabel]="getBindLabel()"
                        [bindValue]="getBindValue()"
                        [(ngModel)]="request.entidades_seleccionadas"
                        [multiple]="true"
                        [closeOnSelect]="false"
                        [clearSearchOnAdd]="true"
                        placeholder="Selecciona elementos..."
                        [loading]="loadingEntities"
                        [clearable]="true"
                        [searchable]="true">
                        
                        <ng-option *ngFor="let item of getEntitiesByType()" [value]="item[getBindValue()]">
                            <span [ngSwitch]="request.tipo_entidad">
                                <!-- Para Prospectos -->
                                <span *ngSwitchCase="'PRO'">
                                    {{item.nombre}} {{item.apellido}} - {{item.empresa}}
                                </span>
                                <!-- Para Contactos -->
                                <span *ngSwitchCase="'CNT'">
                                    {{item.nombre}} {{item.apellido}} - {{item.cuenta?.nombre}}
                                </span>
                                <!-- Para Cuentas -->
                                <span *ngSwitchCase="'ACC'">
                                    {{item.nombre}} - {{item.industria?.nombre}}
                                </span>
                            </span>
                        </ng-option>
                    </ng-select>
                    
                    <!-- Mostrar contador de elementos seleccionados -->
                    <small class="text-muted mt-2" *ngIf="request.entidades_seleccionadas?.length > 0">
                        {{request.entidades_seleccionadas.length}} elemento(s) seleccionado(s)
                    </small>
                </div>
            </div>
            }

            @if(tipoSeleccion === 'masiva'){
            <div class="prospect-form mt-5">
                <div>
                    <label class="login-label" for=""><p class="color-org d-inline">*</p> Tipo cliente:</label>
                    <select name="" id="" class="crm-input" [(ngModel)]="request.tipo_cliente" (change)="onTipoClienteChange()">
                        <option disabled>elija una opcion</option>
                        <option value="Privado">Cliente privado</option>
                        <option value="Publico">Cliente publico</option>
                    </select>
                </div>
            </div>


            <div class="prospect-form mt-5">
                <div>
                    <label class="login-label" for=""><p class="color-org d-inline">*</p> Industria o rubro:</label>
                    <select name="" id="" class="crm-input" [(ngModel)]="request.industria_id">
                        @for (industria of industrias; track industria) {
                        <option [value]="industria.industria_id">{{ industria.nombre }}</option>
                        }
                    </select>
                </div>
            </div>


            <div class="prospect-form mt-5">
                <div>
                    <label class="login-label" for=""><p class="color-org d-inline">*</p> Tipo de negocio:</label>
                    <select class="crm-input" [(ngModel)]="request.tipo_negocio">
                    <option disabled value="">Seleccione tipo de negocio</option>

                    <ng-container *ngIf="request.tipo_cliente === 'Privado'; else publicoOptions">
                        <option value="Venta Directa">Venta Directa</option>
                        <option value="Licitación">Licitación Pública</option>
                    </ng-container>

                    <ng-template #publicoOptions>
                        <option value="Compra Ágil">Compra Ágil</option>
                        <option value="Licitación Pública">Licitación Pública</option>
                        <option value="Licitación Privada">Licitación Privada</option>
                        <option value="Trato Directo">Trato Directo</option>
                        <option value="Convenio Marco">Convenio Marco</option>
                        <option value="Grandes Compras">Grandes Compras</option>
                        <option value="Trato Directo por Emergencia o Seguridad Nacional">Trato Directo por Emergencia o Seguridad Nacional</option>
                        <option value="Contratación por Registro o Listado de Proveedores">Contratación por Registro o Listado de Proveedores</option>
                    </ng-template>
                    </select>
                </div>
            </div>
            
            <div class="d-grid prospect-form">
                <div class="mt-5">
                    <label class="login-label" for=""><p class="color-org d-inline">*</p> Fecha de última interacción:</label>
                    <input class="crm-input" type="date" name="name" id="name" [(ngModel)]="request.fecha_ultima_interaccion">
                </div>
                <div class="mt-5">
                    <label class="login-label" for=""><p class="color-org d-inline">*</p> Estado comercial:</label>
                    <select name="" class="crm-input" id="" [(ngModel)]="request.estado_comercial">
                        <option *ngFor="let row of estados" [value]="row.id_estado">{{row.nombre}}</option>
                    </select>
                </div>
            </div>
            }

            <hr class="mt-5 mb-5">
            <div class="d-flex flex-row justify-center gap-20 mt-2">
                <button (click)="closeMdl();" class="btn btn-primary-outline text-center">Cancelar</button>
                @if(data.mode === 'edit'){
                    <button class="btn btn-primary text-center">Modificar segmento</button>
                }@else{
                    <button class="btn btn-primary text-center" (click)="addSegment()">A&#241;adir segmento</button>
                }
            </div>
        </div>
    </div>
</div>
